<template>
  <div class="sino-card box-label">
    <!-- 头部开始 -->
    <topPart></topPart>
    <!-- 头部结束 -->
    <div class="my-content" :class="{'own-content':multipleRow.status==1}">
      <div class="list-info-box">
        <!-- 申请信息 -->
        <div class="list-block name-title-box">
          <div class="applyImg"></div>
          <div class="applytxt">申请信息</div>
        </div>
        <!-- 申请信息结束 -->
        <!-- 行数据 -->
        <div class="rowBox" v-for="(objs,index) in arr" :key="index">
          <!-- 标题 -->
          <div class="rowBoxTitle">{{strategyTitle(objs,obj)}}</div>
          <!-- 标题结束 -->
          <!-- 内容 -->
          <div class="type-img-box" @click="tertiumQuid(objs.click,obj.nameId)">
            <div>
              <span :class="'rowBoxConter '+objs.style">{{strategy(objs)}}</span>
              <!-- 图标图片 -->
              <img v-if="objs.titleImgFlag" class="peopleImgStype" src="@/images/peopleTitle.png" />
            </div>
            <div class="step-icon-box">
              <img v-if="objs.titleImgFlag" class="step-icon" src="@/images/step_return.png" />
            </div>
          </div>
          <!-- 图标图片结束 -->
          <!-- 类型图片 -->
          <div class="imgBoxStype" v-if="allowanceFlag(objs)">
            <img class="imgStype" src="@/images/declare.png" />
          </div>
          <!--  类型图片结束 -->

          <!-- 内容结束 -->
        </div>
        <!-- 行数据结束 -->
      </div>
      <!-- 数据盒子 -->
      <div class="conterBox list-info-box">
        <!-- 审批盒子区分 -->
        <!-- 审核模块 -->
        <div v-if="multipleRow.status==1" class="approve">
          <!-- 审核信息 -->
          <div class="list-block-copy name-title-box">
            <div class="applyImg"></div>
            <div class="applytxt">审核信息</div>
          </div>
          <!-- 审核信息结束 -->
          <!-- 审核意见 -->
          <div class="approvaOpinion">
            <!-- 审核意见行 -->
            <div class="name-title-box radio-box">
              <span class="radio-span-box">审核意见</span>
              <div class="radio-item-box">
                <van-radio-group
                  v-model="opinion"
                  @change="transfromAdopt"
                  direction="horizontal"
                  icon-size="23"
                >
                  <van-radio name="1" checked-color="#29BEBC">通过</van-radio>
                  <van-radio name="2" checked-color="#29BEBC">不通过</van-radio>
                </van-radio-group>
              </div>
            </div>
            <!-- 审核意见行结束 -->
            <!-- 审核意见行 -->
            <div class="field-name-title-box radio-box" v-if="approvedAmountSeeFlag">
              <span class="radio-span-box">批准补助金额</span>
              <div class="radio-field-box">
                <el-input
                  :disabled="opinion == 2"
                  class="input input-sel"
                  v-model="approvedAmount"
                  :clearable="true"
                  type="number"
                  @input="changgeNumber()"
                ></el-input>
                <span style="margin-left: 10px">元</span>
              </div>
            </div>
            <!-- 审核意见行结束 -->
            <!-- 审核批注 -->
            <div class="info-box2">
              <p class="textArea-span-title">审核备注</p>
              <van-field
                v-model="textarea"
                rows="3"
                autosize
                type="textarea"
                maxlength="200"
                placeholder="请输入内容，字数在200字以内。"
                show-word-limit
                :clearable="true"
              />
            </div>
            <!-- 审核批注结束 -->
          </div>
          <!-- 审核意见结束 -->
          <!-- 提交按钮 -->
          <div class="sure-box" @click="save">
            <span>确定</span>
          </div>
          <!-- 提交按钮结束 -->
        </div>
        <!-- 审核模块结束 -->
        <!-- 详情模块 -->
        <div v-else>
          <!-- 审核信息 -->
          <div class="list-block-copy name-title-box">
            <div class="applyImg"></div>
            <div class="applytxt">审核信息</div>
            <p class="apply-p1">{{titleToExamine}}</p>
          </div>
          <!-- 审核详情 -->
          <div class="steps-div-box">
            <van-steps direction="vertical" :active="timeActive" active-color="#29BEBC">
              <van-step v-for="(item,index) in approvalList" :key="index">
                <div class="step-box1">
                  <div class="applyImg"></div>
                  <span
                    :class="'applytxt step-text1 ' + transfromStartTitle(item.status,'style')"
                  >{{transfromStartTitle(item.status,'title')}}</span>
                  <p class="step-time-p">{{item.endTime}}</p>
                </div>
                <div class="steps-span-box">
                  <span class="step-item-span">审核节点</span>
                  <span class="span-items">{{item.name}}</span>
                </div>
                <div class="steps-span-box">
                  <span class="step-item-span">审核人</span>
                  <span class="span-items">{{item.userName}}</span>
                </div>
                <div class="steps-span-box">
                  <span class="step-item-span">审核意见</span>
                  <span class="span-items">{{item.idea}}</span>
                </div>
              </van-step>
            </van-steps>
          </div>
          <!-- 审核详情结束 -->
          <!-- 审核签名详情 -->
          <!-- 审核信息 -->
          <div v-if="autographTransfrom(obj.comfortType)" class="name-title-box">
            <div class="list-block-copy">
              <div class="applyImg"></div>
              <div class="applytxt">领用人签名</div>
            </div>
            <div class="bottom-box">
              <div v-if="obj.receiverSign" class="resign resign-box2">
                <img class="sign-img" :src="obj.receiverSign" />
              </div>
              <div v-else class="signa-btn">
                <span class="no-signature">暂无签名</span>
              </div>
            </div>
          </div>
          <!-- 审核详情 -->
          <!-- 审核签名详情结束 -->
          <!-- 审核信息结束 -->
        </div>
        <!-- 详情模块结束 -->
        <!-- 审批盒子区分结束 -->
      </div>
      <!-- 数据盒子结束 -->
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import topPart from "../../../components/topPart";
import { toast } from "@/common/api/api.js";
export default {
  methods: {
    tertiumQuid(flag, id) {
      if (flag) {
        this[flag](id);
      }
    },
    strategyTitle(obj, item) {
      if (obj.labelFun) {
        if (item[obj.key]) {
          return obj.label;
        } else {
          return obj.labelTwo;
        }
      } else {
        return obj.label;
      }
    },
    // 点击人员name跳转个人详情页
    goToPersonalInfo(id) {
      this.$router.push({
        path: "/persinnelDetail",
        query: {
          id,
        },
      });
    },
    changgeNumber() {
      this.approvedAmount = this.approvedAmount.replace(/\s+/g, "");
      if (this.approvedAmount.indexOf(".") != -1) {
        this.approvedAmount = this.approvedAmount.substring(
          0,
          this.approvedAmount.indexOf(".") + 3
        );
      }
      if (!isNaN(this.approvedAmount)) {
        this.applyMoneyCopy = this.approvedAmount;
      } else {
        this.approvedAmount = this.applyMoneyCopy;
      }
    },
    //清除金额
    transfromAdopt() {
      this.approvedAmount = 0;
    },
    //审核标题转换
    transfromStartTitle(status, title) {
      return this.approveStartEnglishTitle[status][title];
    },
    //是否展示签名判断
    autographTransfrom(contentType) {
      if (this.autograph[contentType] == 1) {
        return true;
      } else {
        return false;
      }
    },
    //保存函数
    save() {
      if (this.textarea.length <= 0) {
        toast(this, "审核备注不能为空", "error");
        return;
      }
      var data = {
        comfortType: this.comfortType, //保存类型
        approvedAmount: this.approvedAmount, //保存金额
        opinion: this.textarea,
        type: this.opinion,
        planid: this.multipleRow.planId,
        taskId: this.multipleRow.id,
        taskName: this.multipleRow.name,
        userName: this.multipleRow.startUserName,
        userId: this.multipleRow.startUserId,
      };
      this.centralControl.axios.centralControl(
        "approval",
        (res) => {
          const { code } = res;
          if (code == 200) {
            this.$router.push({
              path: "/approval",
            });
          }
        },
        data
      );
    },
    //图片组展示
    allowanceFlag(objs) {
      if (objs.allowanceImgFlag) {
        if (this.obj.comfortType == 1) {
          if (this.obj.allowance == "1") {
            return true;
          }
        }
      }
      return false;
    },
    //普通转换函数
    ordinary(item, obj) {
      return obj[item.key];
    },
    //策略函数
    strategy(item) {
      return this[item.fun](item, this.obj);
    },
    ordinaryMoneyOrGoods(obj, item) {
      if (item[obj.key]) {
        return item[obj.key];
      } else {
        return item[obj.keyTwo];
      }
    },
    //亲属去世类型转换
    typeDeathTransfrom(item, obj) {
      return this.deathType[obj[item.key]];
    },
    //住院慰问类型转换
    typeTransfrom(item, obj) {
      return this.type[obj[item.key]];
    },
    sexTransfrom(item, obj) {
      return this.sex[obj[item.key]];
    },
    //打开签名
    showPopup(itemId) {
      this.test = !this.test;
      this.selId = itemId;
    },
    //其他类型转换
    otherTypeTransfrom(item, obj) {
      return this.otherType[obj[item.key]];
    },
    //转换数据函数
    transfromData(orderList) {
      for (var a = 0; a < orderList.length; a++) {
        var obj = {
          endTime:
            orderList[a].endTime == null || orderList[a].endTime == ""
              ? ""
              : this.dateFormat(orderList[a].endTime),
          userName: orderList[a].userName,
          name: orderList[a].name,
          status: orderList[a].status,
          idea: orderList[a].idea,
        };
        this.approvalList.push(obj);
        if (obj.status == "audit") {
          this.timeActive = a;
          this.titleToExamine = `正在等待${obj.userName}审核!`;
        }
      }
    },
    //获取审批数据
    getQueryHistoricActivitiInstancebyPlanid(orderNumber) {
      var obj = {
        planid: orderNumber,
      };

      this.centralControl.axios.centralControl(
        "queryHistoricActivitiInstancebyPlanid",
        (res) => {
          const { data, code, message } = res;
          if (code == 200) {
            this.transfromData(data);
          }
        },
        obj
      );
    },
    //格式化时间
    dateFormat(str) {
      if (new Date(str)) {
        return new Date(str).format("yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
    //数组中是对象  对象指定属性去重
    duplicateRemoval(arr, str) {
      for (var a = 0; a < arr.length; a++) {
        for (var b = 0; b < arr.length; b++) {
          if (a != b && arr[a][str] == arr[b][str]) {
            if (
              arr[a]["status"] == arr[b]["status"] &&
              (arr[a]["status"] == "notstarted" || arr[a]["status"] == "audit")
            ) {
              arr.splice(a, 1);
            }
          }
        }
      }
    },
    //起调转换金额
    trasfromMoney(comfortType) {
      this.approvedAmountSeeFlag = this.approvedAmountFlag.includes(
        comfortType
      );
    },
    //获取慰问数据
    getOneData(orderNumber) {
      var data = {
        orderNumber: orderNumber,
      };
      this.centralControl.axios.centralControl(
        "getOneData",
        (res) => {
          const { code, message } = res;
          if (code == 200) {
            //保存值
            this.obj = res.data;
            //获取配置数组
            this.arr = [
              ...this.unchanged,
              ...this.config[res.data.comfortType],
            ];
            this.comfortType = res.data.comfortType;
            this.trasfromMoney(res.data.comfortType);
            this.updateTitle(this.comfortType);
          }
        },
        data
      );
    },
    transfromStart(start) {
      return this.startConfig[start];
    },
    getStartConfig() {
      this.startConfig = this.centralControl.utils.getConfig(
        this.centralControl.config,
        ["sympathy", "approveStartEnglish"]
      );
      //获取慰问配置
      var obj = this.centralControl.utils.getConfig(
        this.centralControl.config,
        ["sympathy"]
      );
      this.startConfig = obj.approveStartEnglish; //获取配置对象
      this.approveStartEnglishTitle = obj.approveStartEnglishTitle; //获取标题配置对象
    },
    //签名标识 转换函数
    transfromAutograph(arr) {
      console.log("执行回调");
      for (var a = 0; a < arr.length; a++) {
        this.autograph[arr[a].flag] = arr[a].signatureIdentification;
      }
    },
    updateTitle(comfortType) {
      var str = "";
      if (this.multipleRow&&this.multipleRow.approvalName) {
        str = this.multipleRow.approvalName + "审批";
      } else {
        str = this.titleConfig[comfortType] + "详情";
      }
      this.centralControl.utils.updateDocumentTitle(str);
    },
    //获取审批签名开关
    getAutograph() {
      this.centralControl.axios.centralControl("getAutograph", (res) => {
        const { code, data, message } = res;
        if (code == 200) {
          this.transfromAutograph(data);
          var orderNumber = this.$route.query.row;
          //查询数据
          this.getOneData(orderNumber);
          //查询审批信息数据
          this.getQueryHistoricActivitiInstancebyPlanid(orderNumber);
        }
      });
    },
    getMultipleRowData(orderNumber) {
      var obj = {
        nowPage: 1, //当前页数
        pageSize: 10, //每页展示多少个
        planId: orderNumber, //订单ID
        sendType: "enquiryAgent", //查询我的审批
      };
      return obj;
    },
    //获取参数
    getReasonsForSubsidyData() {
      var obj = {
        dictType: "hospitalization",
      };
      return obj;
    },
    //获取住院类型审核
    getReasonsForSubsidy() {
      var obj = this.getReasonsForSubsidyData();
      this.centralControl.axios.centralControl(
        "getUserDictValueAllData",
        (res) => {
          const { code, data, message } = res;
          if (code == 200) {
            for (var a = 0; a < data.length; a++) {
              this.type[data[a].dictValue] = data[a].dictLabel;
            }
          }
        },
        obj
      );
    },
    getMultipleRow(orderNumber) {
      var obj = this.getMultipleRowData(orderNumber);
      this.centralControl.axios.centralControl(
        "enquiryAgent",
        (res) => {
          const { code, data, message } = res;
          if (code == 200) {
            if (data.list) {
              for (var a = 0; a < data.list.length; a++) {
                if (data.list[a].status == "1" || data.list[a].status == "2") {
                  this.multipleRow = data.list[a];
                  return;
                }
              }
              this.multipleRow = data.list[0];
            }
          }
        },
        obj
      );
    },
  },
  mounted() {},
  created() {
    //获取申请补助事由
    this.getReasonsForSubsidy();
    //获取签名标识
    this.getAutograph();
    this.getStartConfig();
    //获取去路由穿的值
    var orderNumber = this.$route.query.row;
    var flagRouter = this.$route.query.flagRouter;
    if (!flagRouter) {
      this.getMultipleRow(orderNumber);
    }
  },
  components: {
    topPart,
  },
  data() {
    return {
      applyMoneyCopy: "",
      comfortType: "", //类型标识
      approvedAmountSeeFlag: false, //
      approvedAmountFlag: "4", //展示金额标识
      approvedAmount: "0", //审批补助金额
      approveStartEnglishTitle: {}, //标题配置对象
      timeActive: "-1", //时间轴默认显示的数据条数
      autograph: {}, //签名标识
      startConfig: {}, //状态配置信息
      titleToExamine: "", //等待审核
      textarea: "", //审批备注
      opinion: "1", //审核意见
      multipleRow: {}, //审批事项
      approvalList: [], //审批数组
      sex: {
        1: "男",
        2: "女",
      },
      otherType: {
        1: "意外伤害",
        2: "其他",
      },
      deathType: {
        1: "父亲去世",
        2: "母亲去世",
        3: "爱人去世",
        4: "子女去世",
      },
      type: {
        1: "生育",
        2: "疾病",
      },
      titleConfig: {
        1: "住院慰问",
        2: "亲属去世",
        3: "大病救助",
        4: "困难补助",
        5: "其他慰问",
      },
      name: "详情", //页面名称
      obj: {},
      arr: [],
      unchanged: [
        {
          key: "name",
          label: "姓名",
          titleImgFlag: true,
          click: "goToPersonalInfo",
          fun: "ordinary",
          style: "green",
        },
        { key: "union_name", label: "分会", fun: "ordinary" },
        {
          key: "applyDate",
          label: "申请日期",
          fun: "ordinary",
        },
        { key: "dept_name", label: "科室", fun: "ordinary" },
      ],
      config: {
        //渲染配置
        1: [
          {
            key: "secondaryType",
            label: "住院类型",
            allowanceImgFlag: true,
            fun: "typeTransfrom",
          },
          {
            key: "dataApplication",
            label: "住院日期",
            fun: "ordinary",
          },

          { key: "reason", label: "住院事由", fun: "ordinary" },
        ],
        2: [
          {
            keyTwo: "money",
            key: "goods",
            labelTwo: "申请补助金额",
            label: "申请补助物品",
            labelFun: "moneyOrGoods",
            fun: "ordinaryMoneyOrGoods",
          },
          {
            key: "secondaryType",
            label: "申请补助事由",
            fun: "typeDeathTransfrom",
          },
        ],
        3: [
          {
            key: "reason",
            label: "申请原因及现状",
            fun: "ordinary",
          },
        ],
        4: [
          { key: "sex", label: "性别", fun: "sexTransfrom" },
          { key: "age", label: "年龄", fun: "ordinary" },
          { key: "money", label: "申请补助金额", fun: "ordinary" },
          {
            key: "reason",
            label: "申请补助原因",
            fun: "ordinary",
          },
        ],
        5: [
          { key: "secondaryType", label: "类型", fun: "otherTypeTransfrom" },
          {
            key: "reason",
            label: "申请原因及现状",
            fun: "ordinary",
          },
        ],
      },
    };
  },
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/theme.styl';
@import '../../../assets/stylus/common.styl';

.radio-field-box {
  >>> .el-input__inner:focus {
    border-color: $main-bgColor;
    outline: 0;
  }
}

.bottom-box {
  margin: 15px 15px;
}

.signa-btn {
  width: 100%;
  background: #F4F5F9;
  color: $text-gray;
  text-align: center;
  padding: 11px 0;
  font-weight: bold;
  font-size: 18px;
  border-radius: 8px;
}

.no-signature {
  font-size: 14px;
  padding: 10px 0px;
}

.resign {
  padding: 10px 0px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  margin-left: 40%;

  .sign-img {
    width: 40px;
    height: 28px;
    margin: auto;
  }

  .resign-txt {
    color: $default-color;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    font-style: normal;
  }
}

.img {
  width: 18px;
  height: 18px;
  margin-right: 5px;
  vertical-align: sub;
}

.step-item-span {
  width: 80px;
}

.steps-div-box {
  position: relative;

  >>> .van-step__circle {
    // height: 10px;
    margin-top: -10px;
  }
}

.textArea-span-title {
  margin: 20px 0 5px;
}

.van-cell {
  background: #F5F6FB;
  margin: 20px 0 15px;
}

.span-items {
  color: $text-gray;
  flex: 1;
}

.steps-span-box {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $text-black;
  display: flex;
  margin: 10px auto;
}

.info-box2 {
  padding: 0 15px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $text-black;
}

.step-box1 {
  flexDiv();
  background: rgba(244, 245, 249, 1);
  border-radius: 30px;
  padding: 10px 10px;
}

.apply-p1 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 75, 75, 1);
}

.van-radio--horizontal {
  margin-right: 30px;
}

.step-time-p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $text-black;
}

.radio-span-box {
  width: 130px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $text-black;
}

.radio-item-box {
  flex: 1;
}

.radio-field-box {
  width: 150px;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.el-textarea {
  margin: 10px 0;
}

.radio-box {
  flexDiv();
}

.my-content {
  myContent();
  bottom: 0;
}

.step-text1 {
  font-weight: 500 !important;
}

.own-content {
  bottom: 74px;
}

.list-info-box {
  background: #fff;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.type-img-box {
  display: flex;
  flex: 1;
  align-items: center;
  padding-left: 10px;
}

.step-icon-box {
  flex: 1;
  text-align: right;
}

.sure-box {
  height: 44px;
  background: $main-bgColor;
  border-radius: 5px;
  line-height: 44px;
  color: #fff;
  width: 90%;
  text-align: center;
  margin: 0 auto 0;
  position: fixed;
  bottom: 15px;
  left: 0;
  right: 0;
}

.sign-btn {
  flex: 1;
  color: #38c7c4;
  border: 1px solid;
  background-color: #fff;
}

.resign-txt {
  /* color: $default-color; */
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
}

.name-title-box {
  padding: 15px 15px 12px;
  border-bottom: 1px solid #EFEFF4;
  margin-bottom: 8px;
  letter-spacing: 1px;
}

.resign-box2 {
  border: 1px solid #e5e5e5;
  text-align: center;
  margin: auto;
  margin: 10px auto;
  padding: 16px;
}

.field-name-title-box {
  padding: 0px 15px 8px;
  border-bottom: 1px solid #EFEFF4;
  margin-bottom: 8px;
  letter-spacing: 1px;
}

.sign-img {
  width: 141px;
  height: 32px;
}

.resign {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
}

.title {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  /* color: $text-black; */
}

.sign-up {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 10px;
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  display: flex;
  padding: 0 15px;
}

.approvaOpinion {
  // padding-top: 0.4rem;
  // padding-left: 0.5rem;
}

.approve {
}

.peopleImgStype {
  width: 14px;
  height: 14px;
  margin-left: 5px;
}

.peopleImgBoxStype {
  display: inline-block;
  width: 7%;
  text-align: center;
}

.imgStype {
  width: 100%;
}

.conterBox {
  position: relative;
}

.imgBoxStype {
  display: inline-block;
  width: 30%;
}

.imgStyle {
  width: 100%;
}

.red {
  color: red !important;
}

.rowBoxConter {
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $text-gray;
}

.green {
  color: $main-bgColor;
}

.list-block {
  display: flex;
  height: 0.5rem;
  align-items: center;
}

.list-block-copy {
  display: flex;
  height: 0.5rem;
  align-items: center;
  padding-top: calc(0.3rem);
}

.applytxt {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  color: $text-black;
  margin-left: 5px;
  width: 25%;
}

.applyImg {
  width: 7px;
  height: 7px;
  background-color: $main-bgColor;
}

.rowBox {
  padding: 0 15px;
  line-height: 32px;
  display: flex;
}

.rowBoxTitle {
  width: 25%;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $text-black;
}
</style>